import React, { useEffect } from 'react';
import { ChevronLeft, ChevronRight } from 'lucide-react';
import { Dialog, DialogContent, DialogTitle, DialogDescription } from './ui/dialog';

const Lightbox = ({ items, index, onChange, labels }) => {
  const open = index !== null;
  const count = items.length;
  const go = (d) => onChange((index + d + count) % count);

  useEffect(() => {
    if (!open) return;
    const onKey = (e) => {
      if (e.key === 'ArrowRight') go(1);
      if (e.key === 'ArrowLeft') go(-1);
    };
    window.addEventListener('keydown', onKey);
    return () => window.removeEventListener('keydown', onKey);
  });

  const item = open ? items[index] : null;
  const touch = React.useRef(null);
  const onTouchStart = (e) => { touch.current = e.touches[0].clientX; };
  const onTouchEnd = (e) => {
    if (touch.current === null) return;
    const dx = e.changedTouches[0].clientX - touch.current;
    touch.current = null;
    if (Math.abs(dx) > 40) go(dx < 0 ? 1 : -1);
  };
  const arrow = 'absolute top-1/2 -translate-y-1/2 w-11 h-11 rounded-full bg-white/90 hover:bg-white shadow-lg flex items-center justify-center transition-[transform,background-color] hover:scale-105';

  return (
    <Dialog open={open} onOpenChange={(o) => !o && onChange(null)}>
      <DialogContent
        className="max-w-5xl w-[94vw] p-0 bg-transparent border-0 shadow-none [&>button]:text-white [&>button]:opacity-90 [&>button]:-top-9 [&>button]:right-0 [&>button>svg]:w-6 [&>button>svg]:h-6"
        data-testid="lightbox"
      >
        <DialogTitle className="sr-only">{item?.caption}</DialogTitle>
        <DialogDescription className="sr-only">{labels.description}</DialogDescription>
        {item && (
          <figure className="relative" onTouchStart={onTouchStart} onTouchEnd={onTouchEnd} data-testid="lightbox-swipe-area">
            <img
              src={item.src}
              alt={item.caption}
              className="w-full max-h-[78vh] object-contain rounded-xl"
              data-testid="lightbox-image"
            />
            <figcaption className="font-head font-semibold text-white text-center text-sm md:text-base mt-4 px-12" data-testid="lightbox-caption">
              {item.caption}
              <span className="block font-body font-normal text-white/60 text-xs mt-1">{index + 1} / {count}</span>
            </figcaption>
            <button onClick={() => go(-1)} aria-label={labels.prev} className={`${arrow} left-2 md:-left-16`} data-testid="lightbox-prev">
              <ChevronLeft className="w-6 h-6" style={{ color: 'var(--navy)' }} />
            </button>
            <button onClick={() => go(1)} aria-label={labels.next} className={`${arrow} right-2 md:-right-16`} data-testid="lightbox-next">
              <ChevronRight className="w-6 h-6" style={{ color: 'var(--navy)' }} />
            </button>
          </figure>
        )}
      </DialogContent>
    </Dialog>
  );
};

export default Lightbox;
